import React, { useEffect } from 'react';
import classes from './style.module.scss';
import Modal from '~/app/common/Modal';
import { IssueDetails } from '~/types';
import Header from './Header';
import Form from './Form';
import { useStoreActions, useStoreState } from '~/store';

export interface CompleteIssueProps {
    open: boolean
    issueDetails?: IssueDetails
    onSave?: (id: IssueDetails['id']) => void
    onClose: () => void
}

export type CompleteIssueComponent = React.FC<CompleteIssueProps>;

const CompleteIssue = ({ open, issueDetails, onSave, onClose }) => {
    const costCategoryAction = useStoreActions(actions => actions.issue.fetchCostCategories);
    const fetchHPCodesAction = useStoreActions(actions => actions.issue.fetchHPCodes);
    const fetchWorkTypesAction = useStoreActions(actions => actions.issue.fetchWorkTypes);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const hasSimplifiedWorkorderEnabled = useStoreState(state => state.issue.data?.hasSimplifiedWorkorderEnabled ?? false);

    useEffect(() => {
        if(!netWorkStatus && hasSimplifiedWorkorderEnabled) {
            issueDetails?.departmentId && costCategoryAction(issueDetails?.departmentId);
            fetchHPCodesAction();
            fetchWorkTypesAction();
        }
    }, [fetchHPCodesAction, fetchWorkTypesAction, hasSimplifiedWorkorderEnabled, netWorkStatus, issueDetails?.departmentId, costCategoryAction]);
    
    return (
        <>
            <Modal className={classes['completeIssueModel']} open={open} onClose={onClose} position={'bottom'}>
                <Header />
                <Form onClose={onClose} issueDetails={issueDetails} onSave={onSave} />
            </Modal>
        </>
    );
};

export default CompleteIssue;